const browserLocale = (window.navigator.language && window.navigator.language.split('-')[0]);
const defaultLocale = browserLocale.match(/(en|pt)/)
                    ? (`${browserLocale[0].toUpperCase()}${browserLocale[1]}`) : ('Pt');

console.log(
    browserLocale,
    defaultLocale
);

export { defaultLocale };



// WEBPACK FOOTER //
// ./app/locale.js